import React from 'react';
import { createPortal } from 'react-dom';

export function PortHoverTooltip({
  title,
  lines,
  x,
  y,
}: {
  title: string;
  lines: string[];
  x: number;
  y: number;
}) {
  if (typeof document === 'undefined') return null;
  return createPortal(
    <div
      className="port-hover-tooltip"
      style={{ left: x, top: y }}
      role="tooltip"
    >
      <div className="port-hover-tooltip-title">{title}</div>
      {lines.map((line) => (
        <div
          key={line}
          className={`port-hover-tooltip-line${line.includes('→') || line.includes('↔') ? ' port-hover-tooltip-line-center' : ''}`}
        >
          {line}
        </div>
      ))}
    </div>,
    document.body
  );
}
